import { axiosInstance as API } from "@/lib/axios";
import { Cart } from "@/types/cart.types";
import { CartSchema } from "@/lib/validations/api.schema";

export const cartApi = {
    async getCart(): Promise<Cart> {
        const res = await API.get("/cart");
        return CartSchema.parse(res.data.data);
    },

    async addItem(productId: string, attributeOptionId: string, quantity: number): Promise<Cart> {
        const res = await API.post("/cart/items", {
            productId,
            attributeOptionId,
            quantity,
        });

        return CartSchema.parse(res.data.data);
    },

    async updateItem(itemId: string, quantity: number): Promise<Cart> {
        const res = await API.patch("/cart/items/quantity", {
            itemId,
            quantity,
        });

        return CartSchema.parse(res.data.data);
    },

    async removeItem(itemId: string) {
        await API.delete(`/cart/items/${itemId}`);
    },

    async clearCart() {
        await API.delete("/cart");
    },

    async mergeGuestCart(sessionId: string): Promise<Cart> {
        const res = await API.post("/cart/merge", { sessionId });
        return CartSchema.parse(res.data.data);
    },
};